import React, { useCallback } from 'react';
import Avatar from 'react-avatar';
import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from '@mui/material';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../Components/MaterialTableStyle/StyleTableCell';
import ETHLOGO from '../../Assets/images/Icons/Ethreum.svg';
import DAILOGO from '../../Assets/images/Icons/DAILogo.png';
import DATAIMG from '../../Assets/images/AirdropImg/DataImg.png';

import { FormatDate } from '../../Components/DateFormats/DateFromat';
import { useReferral } from './useReferral';
import { Convertor } from '../../utils/convertor';
import Button from '@mui/material/Button';
import { IoIosCopy } from 'react-icons/io';
import { useAccount } from 'wagmi';
import { toast } from 'react-toastify';
import { AppConfig } from '../../Config/app-config';
import { ReferralInviteType } from '../../types/referralInvite.type';
import ConnectButton from '../../WagmiProvider/ConnectButton';

type ReferralTableProps = {
  referralCode: string;
  isLoading: boolean;
  referralInvites: ReferralInviteType[];
};

const ReferralTable = ({
  referralCode,
  isLoading = false,
  referralInvites = [],
}: ReferralTableProps) => {
  const { isConnected } = useAccount();

  const amountFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });

  const copyToClipboard = useCallback(
    async (copyLink: boolean = false) => {
      const codeurl = new URL(
        `${AppConfig.appUrl}${AppConfig.routes.airdrop}/${referralCode}`,
      );
      if (copyLink) {
        await navigator.clipboard.writeText(codeurl.toString());
        toast.success('Referral Link Copied Successfully!');
      } else {
        await navigator.clipboard.writeText(referralCode.toString());
        toast.success('Code Copied Successfully!');
      }
    },
    [referralCode],
  );

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        display={'flex'}
        flexDirection={{
          lg: 'row',
          md: 'row',
          sm: 'column',
          xs: 'column',
        }}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Grid
          item
          md={6}
          xs={12}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
        >
          <h4 className="m-0 p-0" id="referralLeaderboardId">
            Referral Leaderboard
          </h4>
          <Grid
            item
            className="py-1 px-3 mx-2"
            style={{ background: '#30241d', borderRadius: '25px' }}
          >
            <p className="m-0 p-0" style={{ fontSize: '16px' }}>
              Total Invites :
              <span className="mx-2" style={{ fontWeight: '600' }}>
                {referralInvites.length}
              </span>
            </p>
          </Grid>
        </Grid>
        <Grid
          item
          className=""
          md={6}
          xs={12}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          marginTop={{ md: 0, xs: 3 }}
          justifyContent={'flex-end'}
        >
          {isConnected ? (
            Boolean(referralCode) ? (
              <div className="d-flex gap-4">
                <Button
                  className="!tracking-widest"
                  sx={{
                    height: '45px',
                    width: 'auto',
                    backgroundColor: '#000000',
                    border: 0.75,
                    borderColor: '#FC9D4B',
                    borderRadius: '10px',
                    color: '#FFE584',
                    fontWeight: 'semibold',
                    fontFamily: 'PoppinsRegular',
                    boxShadow: '0px 0px 13px 1px #FC9D4B',
                    fontSize: {
                      xs: '18px', // For extra small screens (mobile)
                    },
                    padding: {
                      xs: '12px', // For extra small screens
                      md: '15px', // For medium screens
                    },
                    '&:hover': {
                      background:
                        'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                      color: '#ffffff',
                    },
                    textTransform: 'none',
                  }}
                  onClick={() => copyToClipboard(true)}
                >
                  Your referral link
                  <IoIosCopy size={'20px'} color={'#FFE584'} className="mx-2" />
                </Button>
                <Button
                  className="!tracking-widest"
                  sx={{
                    height: '45px',
                    width: 'auto',
                    backgroundColor: '#000000',
                    border: 0.75,
                    borderColor: '#FC9D4B',
                    borderRadius: '10px',
                    color: '#FFE584',
                    fontWeight: 'semibold',
                    fontFamily: 'PoppinsRegular',
                    boxShadow: '0px 0px 13px 1px #FC9D4B',
                    fontSize: {
                      xs: '18px', // For extra small screens (mobile)
                    },
                    padding: {
                      xs: '12px', // For extra small screens
                      md: '15px', // For medium screens
                    },
                    '&:hover': {
                      background:
                        'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                      color: '#ffffff',
                    },
                    textTransform: 'none',
                  }}
                  onClick={() => copyToClipboard()}
                >
                  {referralCode}

                  <IoIosCopy size={'20px'} color={'#FFE584'} className="mx-2" />
                </Button>
              </div>
            ) : null
          ) : (
            <Grid
              item
              className="BridgeGlassCard"
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <ConnectButton title="Invite Friends" />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        sm={12}
        display={'flex'}
        flexDirection={'row'}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        className="walletAction_Card mt-4 mb-4"
      >
        <Grid
          container
          lg={12}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          className=""
        >
          <TableContainer
            className="customeScroll"
            sx={{ height: { lg: '40vh', sm: '60vh' }, overflowY: 'auto' }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <TableCell
                    style={{
                      backgroundColor: '#3B3B3D',
                      color: '#ffffff',
                      fontSize: '14px',
                      fontFamily: 'Poppins',
                      borderTopLeftRadius: '10px',
                    }}
                  >
                    No
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#3B3B3D',
                      color: '#ffffff',
                      fontSize: '14px',
                      fontFamily: 'Poppins',
                    }}
                  >
                    User
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#3B3B3D',
                      color: '#ffffff',
                      fontSize: '14px',
                      fontFamily: 'Poppins',
                    }}
                  >
                    Joined On
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#3B3B3D',
                      color: '#ffffff',
                      fontSize: '14px',
                      fontFamily: 'Poppins',
                    }}
                  >
                    Staked Amount
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#3B3B3D',
                      color: '#ffffff',
                      fontSize: '14px',
                      fontFamily: 'Poppins',
                      borderTopRightRadius: '10px',
                    }}
                  >
                    Status
                  </TableCell>
                </StyledTableRow>
              </TableHead>
              {!isLoading ? (
                referralInvites?.length > 0 ? (
                  <TableBody>
                    {referralInvites.map((invite, idx) => (
                      <StyledTableRow
                        key={`invite-${idx}`}
                        style={
                          idx % 2 == 0
                            ? { background: '#FFFFFF0F' }
                            : { background: '#ffffff17' }
                        }
                      >
                        <StyledTableCell>
                          <span>{idx}</span>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Grid
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                          >
                            <Avatar name="U U" size={'30px'} round={true} />

                            <span className="mx-2">
                              {`${invite?.walletAddress?.slice(0, 6)}....${invite?.walletAddress?.slice(-6)}`}
                            </span>
                          </Grid>
                        </StyledTableCell>
                        <StyledTableCell>
                          <span>
                            {FormatDate(new Date(invite?.createdAt).getTime())}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell>
                          <div className="flex w-28 justify-end gap-2 items-center">
                            <span>
                              {amountFormatter.format(
                                Convertor.weiToEth(invite?.ethAmount),
                              )}
                            </span>
                            <img
                              src={ETHLOGO}
                              alt="ETH"
                              style={{ height: '20px', width: '20px' }}
                              className="imgcss"
                            />
                          </div>
                        </StyledTableCell>
                        <StyledTableCell>
                          {Number(invite?.ethAmount) > 0 ? (
                            <span>Staked</span>
                          ) : (
                            <span>Yet To Stake</span>
                          )}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell colSpan={9} align="center">
                        <div className="flex justify-center w-full items-center gap-4">
                          <img
                            src={DATAIMG}
                            width={'120px'}
                            height={'120px'}
                            alt="logo"
                          />
                          <p className="text-center text-light mt-3">
                            No Transaction Available
                          </p>
                        </div>
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                )
              ) : (
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell colSpan={7} align="center">
                      <span className="regular">
                        <CircularProgress style={{ color: '#FFFF' }} />
                      </span>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReferralTable;
